import dynamic from 'helpers/dynamic';
import { ColorClubMatas2, Spacing24, Spacing8 } from 'autogen/design-tokens/tokens';
import PageHeader from 'components/generic/PageHeader';
import { Typography } from 'components/generic/typography';
import React from 'react';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';

const Container = styled.div`
    ${breakpoint.up(sizes.lg)} {
        display: grid;
        grid-template-columns: 70px 1fr;
        gap: 0 ${Spacing24};
    }
`;

const GiftIcon = styled(dynamic(() => import('icons/Gift.svg?react')))`
    display: none;

    ${breakpoint.up(sizes.lg)} {
        display: block;
        grid-column: 1;
        grid-row-end: -1;
        width: 70px;
        height: 70px;
    }
`;

const TextContainer = styled.div`
    display: grid;
    text-align: left;
    gap: ${Spacing8};

    ${breakpoint.up(sizes.lg)} {
        grid-column: 2;
    }
`;

const Description = styled(Typography.Body)`
    margin-bottom: 0;
`;

interface IHeader {
    model: {
        headline: string;
        description?: string;
    };
}

export default function Header({ model }: IHeader): JSX.Element {
    const { headline, description } = model;

    return (
        <PageHeader.WithStripes primaryColor={ColorClubMatas2}>
            <Container>
                <GiftIcon />
                <TextContainer>
                    <Typography.Headline as="h1" size="L">
                        {headline}
                    </Typography.Headline>
                    {description && (
                        <Description size="L" dangerouslySetInnerHTML={{ __html: description }} />
                    )}
                </TextContainer>
            </Container>
        </PageHeader.WithStripes>
    );
}
